/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import Vue from 'vue'

/**************************************************************************************************/
/** @import Constants                                                                            **/
/**************************************************************************************************/
import { Documents } from '@/Constants/Documents'
import { VueRouter } from '@/Constants/VueRouter'

/**************************************************************************************************/
/** @import Models                                                                               **/
/**************************************************************************************************/
import { UserDTO } from '@/Models/UserDTO'

/**************************************************************************************************/
/** @export Class @name RouterHelper                                                             **/
/**************************************************************************************************/
export class RouterHelper
{
	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public static redirectToCorrectCPanelView(vueInstance: Vue, user: UserDTO) : void
	{
		// Existen dos tipos principales de rutas, internas y externas.
		// Es importante a cual tipo se debe redireccionar segun el usuario.
		const isClientUser = user?._idRole === Documents.Roles.Kreis.CLIENT
		const CPanelRoute  = isClientUser ? VueRouter.Views.Modules.EXTERNAL_CPANEL.NAME : VueRouter.Views.Modules.INTERNAL_CPANEL.NAME
		vueInstance.$router.push({ name: CPanelRoute, params: { moduleEnvironment: isClientUser ? 'External' : 'Internal', successLogin: 'true' } })
	}
}